import { createIntl, createIntlCache } from 'react-intl'

let cache
let intl

const IntlSetup = props => {
  if (cache) {
    cache = null
  }

  cache = createIntlCache()
  intl = createIntl(props, cache)

  return intl
}

export { IntlSetup, intl }
